/**
 * How a patient medication overlaps with another item on the same list (#333), worked out by the server
 * (v2 patient list). The list view shows SameDrug in red and SameCategory in yellow.
 */
export enum MedicationOverlapKind {
  None = 0,
  SameDrug = 1,
  SameCategory = 2
}
